import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import { EventEmitter } from 'fbemitter';
import { addStoppablePlayer, getStoppablePlayers, registerStoppableMedia, removeStoppablePlayer, stopAllMedia } from '../utils/media-stopping-utils';
import { Ticker } from '../utils/Ticker';

/**
 * VideoPlayerControlsAdapter
 *  handles the events from a video element and
 *  connects them to a "mediaPlayer" interface
 */
export var VideoPlayerControlsAdapter = function () {
  VideoPlayerControlsAdapter.stopAll = function stopAll() {
    var players = getStoppablePlayers(VideoPlayerControlsAdapter);
    players.forEach(function (player) {
      return player.isPlaying && player.pause();
    });
  };

  function VideoPlayerControlsAdapter() {
    var _this = this;

    _classCallCheck(this, VideoPlayerControlsAdapter);

    this.setTimeAsFraction = function (percentagePosition) {
      var newTime = _this.duration * percentagePosition;
      if (_this.video.currentTime !== newTime) {
        _this.videoSeekStartHandler();
        _this.video.currentTime = newTime;
      }
    };

    this.videoPlayHandler = function () {
      _this.ticker.startTicking();
      _this.emitter.emit('onVideoPlay');
    };

    this.videoPauseHandler = function () {
      _this.ticker.stopTicking();
      _this.emitter.emit('onVideoPause');
    };

    this.videoEndHandler = function () {
      _this.ticker.stopTicking();
      _this.emitter.emit('onVideoEnd');
    };

    this.videoSeekStartHandler = function () {
      _this.emitter.emit('onVideoSeekStart');
    };

    this.videoSeekedHandler = function () {
      _this.emitter.emit('onVideoSeeked');
    };

    this.videoLoadedHandler = function () {
      _this.loaded = true;
      _this.emitter.emit('onVideoLoaded');
    };

    this.emitter = new EventEmitter();
    this.video = null;
    this.ticker = new Ticker();
    this.loaded = false;
    addStoppablePlayer(this);
  }

  VideoPlayerControlsAdapter.prototype.clearMedia = function clearMedia() {
    removeStoppablePlayer(this);
  };

  VideoPlayerControlsAdapter.prototype.setVideo = function setVideo(video) {
    this.video = video;
    this.video.onended = this.videoEndHandler;
    this.video.onplay = this.videoPlayHandler;
    this.video.onpause = this.videoPauseHandler;
    this.video.onseeked = this.videoSeekedHandler;
    this.video.onloadeddata = this.videoLoadedHandler;
  };

  VideoPlayerControlsAdapter.prototype.play = function play() {
    stopAllMedia();
    this.video.play();
  };

  VideoPlayerControlsAdapter.prototype.pause = function pause() {
    this.video.pause();
  };

  VideoPlayerControlsAdapter.prototype.onPlay = function onPlay(handler) {
    return this.emitter.addListener('onVideoPlay', handler);
  };

  VideoPlayerControlsAdapter.prototype.onPause = function onPause(handler) {
    return this.emitter.addListener('onVideoPause', handler);
  };

  VideoPlayerControlsAdapter.prototype.onEnd = function onEnd(handler) {
    return this.emitter.addListener('onVideoEnd', handler);
  };

  VideoPlayerControlsAdapter.prototype.onSeekStart = function onSeekStart(handler) {
    return this.emitter.addListener('onVideoSeekStart', handler);
  };

  VideoPlayerControlsAdapter.prototype.onSeeked = function onSeeked(handler) {
    return this.emitter.addListener('onVideoSeeked', handler);
  };

  VideoPlayerControlsAdapter.prototype.onLoaded = function onLoaded(handler) {
    return this.emitter.addListener('onVideoLoaded', handler);
  };

  VideoPlayerControlsAdapter.prototype.onTick = function onTick(handler) {
    return this.ticker.onTick(handler);
  };

  _createClass(VideoPlayerControlsAdapter, [{
    key: 'isPlaying',
    get: function get() {
      return this.video && !this.video.paused;
    }
  }, {
    key: 'isLoaded',
    get: function get() {
      return this.loaded;
    }
  }, {
    key: 'position',
    get: function get() {
      return this.video.currentTime;
    }
  }, {
    key: 'duration',
    get: function get() {
      return this.video.duration;
    }
  }, {
    key: 'progress',
    get: function get() {
      return 1 - (this.duration - this.position) / this.duration;
    }
  }]);

  return VideoPlayerControlsAdapter;
}();

registerStoppableMedia(VideoPlayerControlsAdapter);